import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ApplicationEmitter {
  getDataEmitter: EventEmitter<unknown> = new EventEmitter();
}
